const getAno = () => String(new Date().getMonth() == 0 ? new Date().getFullYear() - 1 : new Date().getFullYear());

const getMes = () => {
    let data = new Date();
    data.setMonth(data.getMonth() - 1);

    return data.getMonth() < 9 ? `0${data.getMonth() + 1}` : data.getMonth() + 1;
};

const INITIAL_STATE = {
    registro: {},
    aguardando: false,
    modoTela: "lista",
    tipoModoTela: null,
    totalFaturasImportadas: 0,
    lista: [],
    listaAgua: [],
    listaGraficoGeracaoSaldo: [],
    listaFaturasVencidas: [],
    listaCliente: [],
    listaClienteAgua: [],
    listaUnidadeConsumidora: [],
    listaUnidadeConsumidoraAgua: [],
    listaConcessionaria: [],
    listaConcessionariaAgua: [],
    listaProdutoTipo: [],
    filtro: {
        ano: getAno(),
        mes: getMes(),
        id_cliente: null,
        id_unidade_consumidora: null,
        id_concessionaria: null,
        unidades_consumidoras: [],
        id_grupo_faturamento: null,
        irrigante: true,
        naoIrrigante: true,
        id_empenho: null,
        geracao_solar: null,
        tipo_filtro_uc: "unidade",
    },
    ultimoFiltroUtilizado: null,
    ultimoFiltroUtilizadoAgua: null,
    listaGraficoCusto: [],
    listaGraficoCustoUnidade: [],
    listaMeses: [
        { id: "01", valor: "Janeiro" },
        { id: "02", valor: "Fevereiro" },
        { id: "03", valor: "Março" },
        { id: "04", valor: "Abril" },
        { id: "05", valor: "Maio" },
        { id: "06", valor: "Junho" },
        { id: "07", valor: "Julho" },
        { id: "08", valor: "Agosto" },
        { id: "09", valor: "Setembro" },
        { id: "10", valor: "Outubro" },
        { id: "11", valor: "Novembro" },
        { id: "12", valor: "Dezembro" },
    ],
    listaProducaoSolar: [
        { id: "GERADORAS", valor: "GERADORAS" },
        { id: "REMOTAS", valor: "REMOTAS" },
        { id: "SEM GERAÇÃO", valor: "SEM GERAÇÃO" },
        { id: "GERADORAS E REMOTAS", valor: "GERADORAS E REMOTAS" },
    ],
    totalFaturaEmpenho: 0,
    listaUcFaturasRedirecionamento: [], //quando redireciona pra tela de fatura, com uma lista predefinida que deve ser exibida
};

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case "FATURA_MODO_TELA":
            return {
                ...state,
                modoTela: action.payload.modo,
                registro: action.payload.registro,
            };

        case "FATURA_SET_AGUARDANDO":
            return { ...state, aguardando: action.payload };

        case "FATURA_SET_TIPO_MODO_TELA":
            return { ...state, tipoModoTela: action.payload };

        case "FATURA_REDIRECIONAMENTO_LISTADO":
            const listaUCsRedirecionamento = [];
            for (const item of action.payload || []) {
                if (!listaUCsRedirecionamento.find((el) => el.value == item.id_unidade_consumidora)) {
                    listaUCsRedirecionamento.push({ label: item.nome_unidade_consumidora, value: item.id_unidade_consumidora });
                }
            }
            return {
                ...state,
                listaUcFaturasRedirecionamento: action.payload,
                filtro: {
                    ...state.filtro,
                    ano: null,
                    mes: null,
                    unidades_consumidoras: [...listaUCsRedirecionamento],
                },
            };

        case "FATURA_RESET_FILTRO":
            return {
                ...state,
                filtro: {
                    ano: getAno(),
                    mes: getMes(),
                    id_cliente: null,
                    id_unidade_consumidora: null,
                    id_concessionaria: null,
                    unidades_consumidoras: [],
                    id_grupo_faturamento: null,
                    irrigante: true,
                    naoIrrigante: true,
                    id_empenho: null,
                    geracao_solar: null,
                    tipo_filtro_uc: "unidade",
                },
                listaUcFaturasRedirecionamento: [],
            };

        case "FATURA_FILTRO":
            //se tinha lista de redirecionamento redefine o filtro de ano e mês, senão usa o que veio
            return {
                ...state,
                filtro: {
                    ...action.payload,
                    tipo_filtro_uc: action.payload.tipo_filtro_uc || state.filtro.tipo_filtro_uc,
                    ano: state.listaUcFaturasRedirecionamento.length ? getAno() : action.payload.ano,
                    mes: state.listaUcFaturasRedirecionamento.length ? getMes() : action.payload.mes,
                },
                listaUcFaturasRedirecionamento: [],
            };

        case "FATURA_ULTIMO_FILTRO_UTILIZADO":
            //se tinha lista de redirecionamento redefine o filtro de ano e mês, senão usa o que veio
            return {
                ...state,
                ultimoFiltroUtilizado: {
                    ...action.payload,
                },
            };

        case "FATURA_AGUA_ULTIMO_FILTRO_UTILIZADO":
            //se tinha lista de redirecionamento redefine o filtro de ano e mês, senão usa o que veio
            return {
                ...state,
                ultimoFiltroUtilizadoAgua: {
                    ...action.payload,
                },
            };

        case "TOTAL_FATURAS_IMPORTADAS":
            return { ...state, totalFaturasImportadas: action.payload };

        case "FATURA_LISTADO":
            return {
                ...state,
                lista: action.payload,
            };

        case "FATURA_AGUA_LISTADO":
            return {
                ...state,
                listaAgua: action.payload,
            };

        case "FATURA_GRAFICO_GERACAO_SALDO_LISTADO":
            return {
                ...state,
                listaGraficoGeracaoSaldo: action.payload.data,
            };

        case "FATURAS_VENCIDAS_LISTADO":
            return {
                ...state,
                listaFaturasVencidas: action.payload.data,
            };

        case "FATURA_CLIENTE_SELECT_LISTADO":
            return {
                ...state,
                listaCliente: action.payload.data,
            };
        case "FATURA_AGUA_CLIENTE_SELECT_LISTADO":
            return {
                ...state,
                listaClienteAgua: action.payload.data,
            };

        case "FATURA_UNIDADE_CONSUMIDORA_SELECT_LISTADO":
            return {
                ...state,
                listaUnidadeConsumidora: action.payload.data,
            };

        case "FATURA_AGUA_UNIDADE_CONSUMIDORA_SELECT_LISTADO":
            return {
                ...state,
                listaUnidadeConsumidoraAgua: action.payload.data,
            };

        case "FATURA_TOTAL_EMPENHO":
            return {
                ...state,
                totalFaturaEmpenho: action.payload.data || 0,
            };

        case "FATURA_CONCESSIONARIA_SELECT_LISTADO":
            return {
                ...state,
                listaConcessionaria: action.payload.data,
            };

        case "FATURA_CONCESSIONARIA_AGUA_SELECT_LISTADO":
            return {
                ...state,
                listaConcessionariaAgua: action.payload.data,
            };

        case "FATURA_PRODUTO_TIPO_SELECT_LISTADO":
            return {
                ...state,
                listaProdutoTipo: action.payload.data,
            };

        case "FATURA_GRAFICO_CUSTO_LISTADO":
            return {
                ...state,
                listaGraficoCusto: action.payload.data,
            };

        case "FATURA_GRAFICO_CUSTO_UNIDADE_LISTADO":
            return {
                ...state,
                listaGraficoCustoUnidade: action.payload.data,
            };

        default:
            return state;
    }
};
